import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const routes = [{
		name: 'login',
		path: '/login',
		component: () => import('@/views/login'),
		children: [],
		meta: {
			anonymous: true
		}
	},{
		name: '404',
		path: '/404',
		component: () => import('@/views/404'),
		children: [],
		meta: {
			anonymous: true
		}
	},{
		name: 'transit',
		path: '/transit',
		component: () => import('@/views/transit'),
		children: [],
		meta: {
			anonymous: true
		}
	},{
		name: 'register',
		path: '/register',
		component: () => import('@/views/register'),
		children: [],
		meta: {
			anonymous: true
		}
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})


const setAppRoute = async () => {
	const configStore = await store.dispatch('config/get');
	const appRoute = [];
	let defaultRoute = {};
	for (var app in configStore.config) {
		if(!defaultRoute.path){
			defaultRoute = {
				name: configStore.config[app].route.name,
				path: configStore.config[app].route.path,
				component: () => import('@/views/index')
			}
			appRoute.push({
				path: '*',
				redirect: configStore.config[app].route.path,
				hidden: true
			});
		}
		appRoute.push({
			name: configStore.config[app].route.name,
			path: configStore.config[app].route.path,
			component: () => import('@/views/index')
		})
	}
	router.addRoutes(appRoute)
}

setAppRoute();

router.afterEach(async (to, from, next) => {
	//还没完成加载config.json
	// if(!to.name){
	// console.log(to)
	// 	return
	// }
	//链接无需验证授权
	if (to.meta && to.meta.anonymous) {
		return
	}
	//console.log(gApp)
	const menuStore = await store.dispatch('menu/get');
	const featureStore =await store.dispatch('feature/get');
	
	let currentMenu = menuStore.list.filter(ele => {
		let item = null
		if (to.fullPath.indexOf(ele.url) >= 0) {
			item = ele.url
		}
		return item
	})[0]
	
	if (!currentMenu){
		//访问第一条记录
		// let menu = menuStore.list.filter(ele => {
		// 	if (ele.url && ele.url != '#') {
		// 		return ele
		// 	}
		// })[0]
		// location.href = menu.url
		return
	} 
	
	//无权访问
	if (currentMenu.feature && !featureStore.keys.some(ele => ele == currentMenu.feature)) {
		router.push({
			path: '/core/401'
		})
		return
	}

	store.commit('menu/updateCurrent', currentMenu)
})
export default router
